export const ASSET_ACQUISITION_MODAL_ID = 'ASSET_ACQUISITION_MODAL_ID';
export const EASY_ACCESS_MODAL_ID = 'EASY_ACCESS_MODAL_ID';
export const STANDARD_EDITORIAL_USAGE_MODAL_ID =
  'STANDARD_EDITORIAL_USAGE_MODAL_ID';

export const CREATIVE_LICENSE_DETAILS_MODAL_ID =
  'CREATIVE_LICENSE_DETAILS_MODAL_ID';

export const SINGLE_IMAGE_CREATIVE_LICENSE_MODAL_ID =
  'SINGLE_IMAGE_CREATIVE_LICENSE_MODAL_ID';

export const SINGLE_IMAGE_EDITORIAL_LICENSE_MODAL_ID =
  'SINGLE_IMAGE_EDITORIAL_LICENSE_MODAL_ID';

export const ULTRAPACK_LICENSE_DETAILS_MODAL_ID =
  'ULTRAPACK_LICENSE_DETAILS_MODAL_ID';
